import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

const PaymentDetails = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setLoading(true);
    }, [isAuthenticated, companyId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        SaleDate: '',
        ReferenceNo: 0,
        CustomerId: '',
        PackingListId: '',
        TotalBilledQuantity: 0,
        TotalBilledAmount: 0,
        Remarks: '',
        Packinglistdeatils: '',
        PaymentType: 0,
        createdBy: userId,
        isSubmit: false,
        BalBox: 0,
        Box: 0,
        TotalBalAmt: 0,
    });

    useEffect(() => {
        fetchData('PaymentApi', `/PaymentData/${id}`, token)
            .then((response) => {
                setLoading(true);
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data.PaymentAndReceipt;
                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });
                    console.log(response);

                    const updatedInvoicedetailsSorted = response.response_data.PaymentAndReceiptPurchaseCollection;
                    setInvoicedeatils(updatedInvoicedetailsSorted);
                    console.log(updatedInvoicedetailsSorted);
                }
            })
            .catch((error) => {
                console.error('Error fetching Invoice Details:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Payment Details (Against Purchase)
                </h6>

                <div className="flex mt-8 w-full sm:w-auto">
                    <Button
                        component={Link}
                        to="/PaymentIndex"
                        className="linkcolor"
                    >
                        <ArrowCircleLeftIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'bolder', marginLeft: '5px', color: '#A91D3A' }}>Back To List</b>
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                
                <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
                    <div className="w-full mb-2 flex">

                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Supplier Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.MasterName}
                                type="text"
                                name='CustomerName'
                                readOnly
                                style={{ height: '35px' }}
                            />

                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Bill Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                type="date"
                                name='BillDate'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Bill Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Payment Mode
                            </label>

                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={(formData.PaymentName)}
                                name='ReferenceDate'
                                readOnly
                                style={{ color: 'darkred', fontWeight: 'bold' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Amount || ''}
                                type="number"
                                placeholder="Amount"
                                name='Amount'
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '35px' }}
                            />
                        </div>

                    </div>
                    <div className="w-full mb-2 flex">
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Bank
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={(formData.BankName)}
                                name='ReferenceDate'
                                readOnly
                                style={{ color: 'darkred', fontWeight: 'bold' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Reference No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.ChequeNumber}
                                type="text"
                                placeholder=""
                                name="ChequeNumber"

                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Reference Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ChequeDate)}
                                type="date"
                                placeholder=""
                                name="ChequeDate"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Reference Details
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.chequeDetails}
                                type="text"
                                placeholder=""
                                name="chequeDetails"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                style={{ height: '35px', width: '100%' }}
                            />
                        </div>

                    </div>
                </div>
            </div>

            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                <div className="w-full mb-2" style={{ backgroundColor: '#c9dedb', marginTop: '-0.15%', overflow: 'auto' }}>
                    <table
                        className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                        style={{ borderCollapse: 'collapse' }}
                    >
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>SL.No</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>BILL DETAILS</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>AMOUNT</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>PAID AMOUNT</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>BALANCE</th>
                            </tr>
                        </thead>

                        <tbody>
                            {invoicedeatils && invoicedeatils.map((item, index) => (


                                <tr key={index} className="border-b"
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                        borderBottom: '1px solid #E0E0E0',
                                        transition: 'transform 0.2s ease-in-out',
                                        cursor: 'pointer',
                                    }}
                                    // onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                    // onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                >
                                    <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '65px' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '250px' }}>{item.Billdetails}</td>

                                    <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                        <input
                                            type="number"
                                            value={item.BillAmount}
                                            className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                            style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FBF6E9', textAlign: 'right' }}
                                            min="0"
                                            aria-label={`Order quantity for item ${item.Id}`}
                                            name="BillAmount"
                                            readOnly
                                        />
                                    </td>

                                    <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                        <input
                                            value={item.Amount || 0}
                                            className="w-full px-1 py-1 border rounded-md"
                                            style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                            name="Amount"
                                            readOnly
                                        />
                                    </td>
                                    <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                        <input
                                            value={item.BillAmount - (item.Amount || 0)}
                                            className="w-full px-1 py-1 border rounded-md"
                                            style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
                                            type="number"
                                            name="BalanceAmount"
                                            readOnly
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </div >
    );
}

export default PaymentDetails;
